import type { TJsonSchema } from "types/utilTypes";

import { compiledClientConfig } from "config";
import { Record } from "immutable";

type TApplicationFlagRestriction = "disabled" | "optional" | "required";

const defaults = {
  adapterless: false,
  adapterName: "",
  canCreateActors: "optional" as TApplicationFlagRestriction,
  canEditPermissions: "optional" as TApplicationFlagRestriction,
  configurationSchema: null as null | TJsonSchema[],
  docsKey: null as null | string,
  id: "",
  imageUrl: "",
  manual: false,
  name: "",
  oauth: "optional" as TApplicationFlagRestriction,
  oauthConfigurationSchema: null as null | TJsonSchema[],
  virtual: false,
};

export class ApplicationModel extends Record<typeof defaults>(defaults) {
  static fromServerData(data: unknown) {
    return new ApplicationModel(
      compiledClientConfig.spog && (data as typeof defaults).imageUrl
        ? {
            ...(data as typeof defaults),
            imageUrl: `/${compiledClientConfig.basePrefix}` + (data as typeof defaults).imageUrl,
          }
        : (data as typeof defaults),
    );
  }
}
